export default "__VITE_ASSET__Cx2snjMH__"